import { Component, ViewChild, TemplateRef, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { Router } from '@angular/router';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-oos-lab-investigation-category',
  templateUrl: './oos-lab-investigation-category.component.html',
  styleUrls: ['./oos-lab-investigation-category.component.scss']
})
export class OosLabInvestigationCategoryComponent implements OnInit, OnDestroy {

  isProcessing = true;
  primObj: any = {};
  templateId: number;
  subDepartment: string;
  categoryId: number;
  categoryName: string = '';
  auditTrail: any = {};
  is_category: boolean = false;

  categoryList: any = [];
  fieldTypeList: any = [];

  categoryDropDown: any = [];
  fieldTypeDropDown: any = [];

  fieldTypeSearchText: string = '';
  categorySearchText: string = '';

  reorderTitle: string = '';
  isReordered: boolean = false;
  selectedReportSectionRowData: any = null;

  constructor(
    private readonly router: Router,
    private readonly elem: ElementRef,
    private readonly dialog: MatDialog,
    private readonly snackBar: MatSnackBar,
    private readonly appService: AppService,
    private readonly paginationService: PaginationService,

    public readonly message: messageService,
  ) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.message.breadcrumbData.fourthLevel = data.template.templateName;
    this.templateId = data.template.templateId;
    this.subDepartment = data.template.qcSubDepartment;
    this.is_category = true;
  }
  focusEmpty() {
    console.log();
  }

  ngOnInit() {
    this.isProcessing = true;



    this.appService.getNonOrgCodeListsByGroupName("FLEXIFIELD_FIELDTYPE").subscribe((data: any) => {
      this.fieldTypeList = data;
      this.selectBoxForFieldType();
    });

    this.appService.getCodeListsByGroup('OOS_QUESTION_CATEGORY').subscribe((data: any) => {
      this.categoryList = data?.filter((c: any) => {
        if (this.subDepartment == 'Analytical')
          return c.codelistCode != 'Sampling' && c.codelistCode != 'Bacterial Endotoxin Test(BET)';
        else return true;
      });
      this.selectBoxForCategory();
      this.getCall();
    })
  }

  ngOnDestroy() {
    this.message.breadcrumbData.fourthLevel = '';
  }

  backToTemplate() {
    this.message.isFromOosCategory = true;
    this.router.navigate(['dashboard/lab-investigation-template'], {
      state: { department: this.subDepartment }
    });
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value); searchBox?.focus();
    }, 0)
  }

  selectBoxForCategory() {
    this.categoryDropDown = this.categoryList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onCategorySelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('category-name', item);
    }
  }

  selectBoxForFieldType() {
    this.fieldTypeDropDown = this.fieldTypeList?.map((type: any) => ({
      valueExp: type.codelistCode,
      displayExp: type.codelistName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.localeCompare(n?.displayExp)) ?? []
  }

  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('field-type', item);
    }
  }

  handleDropDownValidation(fieldId: string, item: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = item ? '#005c8a' : 'red');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. Id → ', fieldId);
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('updatePopup', { static: true }) updatePopup: TemplateRef<any>;
  visibleUpdatePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('fieldsPopup', { static: true }) fieldsPopup: TemplateRef<any>;
  visibleFieldsPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reorderPopup') reorderPopup: TemplateRef<any>;
  visibleReorderPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  resultPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  updatePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  fieldPopupConfig = {
    width: '90%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { left: '105px', top: '5px' },
    maxWidth: '90vw',
  };

  reorderPopupConfig = {
    width: '800px',
    height: 'auto',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '30px' },
  };

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  popupTitle: string = '';
  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.popupTitle = "Add " + (this.is_category ? "Category" : "Field");
    this.primObj = {};
    this.primObj.isActive = true;
    !this.is_category && (this.primObj.categoryName = this.categoryName);
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  editingCategoryIdOrFieldId: number;
  openEditPopup(editingData: any) {
    this.isProcessing = true;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.popupTitle = "Edit " + (this.is_category ? (editingData.CATEGORY_NAME + " Category") : (editingData.FIELD_NAME + " Field"));
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    this.editingCategoryIdOrFieldId = editingData.CATEGORY_OR_FIELD_ID;

    const api = this.is_category ? 'getCategoryById' : 'getFieldById';

    this.appService[api](this.editingCategoryIdOrFieldId).subscribe((template: any) => {
      this.primObj = template;
      this.primObj.updateReason = '';
      this.primObj.isActive = this.primObj.isActive == 'Y';
      this.isProcessing = false;
    })
  }

  deletingCategoryIdOrFieldId: number;
  openDeletePopup(deletingData: any) {
    this.popupTitle = "Delete " + (this.is_category ? "Category" : "Field");
    this.deletingCategoryIdOrFieldId = deletingData.CATEGORY_OR_FIELD_ID;
    this.primObj.deleteReason = "";
    this.is_category && (this.primObj.categoryName = deletingData.CATEGORY_NAME);
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  closeAddEditPopup() {
    this.visibleAddAndEditPopup.close();
  }

  closeDeletePopup() {
    this.visibleDeletePopup.close();
  }

  openFieldsPopup(category: any) {
    this.is_category = false;
    this.categoryId = category.CATEGORY_OR_FIELD_ID;
    this.categoryName = category.CATEGORY_NAME;
    this.visibleFieldsPopup = this.dialog.open(this.fieldsPopup, this.fieldPopupConfig);
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
  }

  closeFieldsPopup() {
    this.is_category = true;
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
    this.visibleFieldsPopup.close();
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element && (element.style.color = 'red');
    });
  }

  addAndEditFunction(primObj: any) {

    const validations = [
      { condition: !primObj.categoryName, id: 'category-name' },
      ...(this.is_category ? [] : [{ condition: !primObj.fieldName, id: 'field-name' }]),
      ...(this.is_category ? [] : [{ condition: !primObj.fieldTypeCode, id: 'field-type' }]),
      ...(this.is_category || ['Large Text', 'Text Field'].includes(primObj.fieldTypeCode)
        ? []
        : [{ condition: !primObj.fieldValues, id: 'field-values' }]
      ),
      { condition: !primObj.updateReason && this.visibleEditButton, id: 'update-reason' }
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);
    if (invalidIds.length > 0) {
      this.fieldValidation(invalidIds);
      this.showSnackBar('Please enter all Mandatory Fields!', 'E');
    } else {
      this.isProcessing = true;

      const obj = {
        templateId: this.templateId,
        categoryName: primObj.categoryName,
        ...!this.is_category && { fieldName: primObj.fieldName },
        ...!this.is_category && { fieldName: primObj.fieldName },
        ...!this.is_category && { fieldTypeCode: primObj.fieldTypeCode },
        ...!this.is_category && primObj.fieldTypeCode != 'Large Text' && primObj.fieldTypeCode != 'Text Field' && primObj.fieldTypeCode != 'Document Repository' && { fieldValues: primObj.fieldValues },
        ...!this.is_category && { instructions: primObj.instructions },
        isActive: primObj.isActive ? 'Y' : 'N',
      }

      if (this.visibleAddButton) {
        this.create(obj);
      } else {
        const modifiedObj = {
          ...obj, categoryOrFieldId: this.editingCategoryIdOrFieldId, categorySeq: primObj.categorySeq, ...!this.is_category && { fieldSeq: primObj.fieldSeq }, updateReason: primObj.updateReason
        }
        this.update(modifiedObj);
      }
    }
  }

  create(obj: any) {
    this.appService.createOosCategoryOrField(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  update(obj: any) {
    this.appService.updateOosCategoryOrField(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.getCall();
          this.visibleAddAndEditPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
        } else {
          this.isProcessing = false;
          this.showSnackBar(Response.result, Response.resultType);
        }
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  deleteFunction(template: any) {
    if (template.deleteReason) {
      this.isProcessing = true;

      const obj = {
        categoryOrFieldId: this.deletingCategoryIdOrFieldId,
        deleteReason: template.deleteReason
      }

      this.appService.deleteOosCategoryOrField(obj).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      const field = document.getElementById('delete-reason') as HTMLInputElement;
      field.style.color = 'red';
    }
  }

  openReorderPopup(reorderFor: string) {
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
    this.reorderTitle = reorderFor + ' Reorder';
    this.isReordered = false;
    this.visibleReorderPopup = this.dialog.open(this.reorderPopup, this.reorderPopupConfig);
  }

  cancelReorder() {
    this.visibleReorderPopup.close();
  }

  dragAndDrop(event: CdkDragDrop<string[]>) {
    this.isReordered = true;
    moveItemInArray(this.grid, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.grid.length; i++) {
      this.grid[i].NEW_ORDER = i + 1;
    }
  }

  async reorderItems() {
    this.isProcessing = true;

    const common_obj = {

      templateId: this.templateId,
    };

    const promises = [];
    const sortedGrid = [...this.grid].sort((a, b) => a.NEW_ORDER - b.NEW_ORDER);

    // Check if we're reordering categories or fields
    if (this.is_category) {

      for (let i = 0; i < sortedGrid.length; i++) {
        const obj = {
          ...common_obj,
          categoryOrFieldId: this.grid[i].CATEGORY_OR_FIELD_ID,
          categoryName: this.grid[i].CATEGORY_NAME,
          isActive: this.grid[i].IS_ACTIVE ? 'Y' : 'N',
          categorySeq: this.grid[i].NEW_ORDER,
          updateReason: this.grid[i].UPDATE_REASON
        };

        promises.push(this.executeReorder(obj));
      }
    } else {

      for (const item of sortedGrid) {
        const obj = {
          ...common_obj,
          categoryOrFieldId: item.CATEGORY_OR_FIELD_ID,
          categoryName: item.CATEGORY_NAME,
          fieldName: item.FIELD_NAME,
          fieldTypeCode: item.FIELD_TYPE_CODE,
          fieldValues: item.FIELD_VALUES,
          instructions: item.INSTRUCTIONS,
          isActive: item.IS_ACTIVE ? 'Y' : 'N',
          fieldSeq: item.NEW_ORDER,
          updateReason: item.UPDATE_REASON
        };

        promises.push(this.executeReorder(obj));
      }

      for (const gridItem of this.grid) {
        const obj = {
          ...common_obj,
          categoryOrFieldId: gridItem.CATEGORY_OR_FIELD_ID,
          categoryName: gridItem.CATEGORY_NAME,
          fieldName: gridItem.FIELD_NAME,
          fieldTypeCode: gridItem.FIELD_TYPE_CODE,
          fieldValues: gridItem.FIELD_VALUES,
          instructions: gridItem.INSTRUCTIONS,
          isActive: gridItem.IS_ACTIVE ? 'Y' : 'N',
          fieldSeq: gridItem.NEW_ORDER,
          updateReason: gridItem.UPDATE_REASON
        };

        promises.push(this.executeReorder(obj));
      }
    }

    Promise.all(promises)
      .then(() => {
        const message = this.is_category ? 'Categories reordered successfully' : 'Fields reordered successfully';
        this.isReordered = false;
        this.getCall();
        this.visibleReorderPopup.close();
        this.showSnackBar(message, 'S');
        this.isProcessing = false;
      })
      .catch((error) => {
        this.isProcessing = false;
        console.error('Error reordering items:', error);
        this.showSnackBar('An error occurred while reordering items.', 'E');
      });
  }

  executeReorder(obj: any): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.appService.updateOosCategoryOrField(obj).subscribe({
        next: (response: any) => {
          if (response.resultType === "S") {
            resolve();
          } else {
            this.isProcessing = false;
            this.showSnackBar(response.result, response.resultType);
            reject(new Error(response.result));
          }
        },
        error: (error) => {
          this.isProcessing = false;
          this.showSnackBar('An error occurred', 'E');
          reject(error);
        }
      });
    });
  }

  parentCheckBox: boolean = false;
  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, template: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : template.CATEGORY_OR_FIELD_ID;
    this.auditTrail.gridName = this.is_category ? "OOS_LAB_INVESTIGATION_TEMPLATE_CATEGORY" : "OOS_LAB_INVESTIGATION_TEMPLATE_FIELDS";
    this.auditTrail.report_And_Popup_Name = 'Lab Investigation ' + (this.is_category ? "Category Audit Trail" : "Field Audit Trail");
    this.dynamicAuditTrailComponent.triggerTrail(template);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.gridObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Lab Investigation ' + (this.is_category ? "Category Report" : "Field Report");
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.gridObj.gridName, this.gridObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  getDynamicLabel() {
    this.isProcessing = true;
    const data = {
      tableName: this.is_category ? "QMS_OOS_LAB_INVESTIGATION_TEMPLATE_CATEGORY_VW" : "QMS_OOS_LAB_INVESTIGATION_TEMPLATE_FIELDS_VW",
      moduleName: null,
      gridName: this.is_category ? "OOS_LAB_INVESTIGATION_TEMPLATE_CATEGORY" : "OOS_LAB_INVESTIGATION_TEMPLATE_FIELDS",
      groupId: 0,
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  grid: any = [];
  gridTemp: any = [];
  selectedGridData: any = [];
  gridObj: any = {};

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    this.selectedGridData = [];
    this.parentCheckBox = false;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    const data = {

      gridName: this.is_category ? "OOS_LAB_INVESTIGATION_TEMPLATE_CATEGORY" : "OOS_LAB_INVESTIGATION_TEMPLATE_FIELDS",
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ?? "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          templateIdFromQmsReportTemplate: this.templateId,
          ...!this.is_category && { oosCategoryName: this.categoryName }
        }
        this.gridObj = { ...data1, ...data };
        this.auditTrail.secondary_obj = data1;
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (const rowData of this.grid) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType === 'CHECKBOX') {
                    rowData[element.columnName] = rowData[element.columnName] === 'Y';
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.getDynamicLabel()
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  columnFilter(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  globalFilter(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  onParentChanged(e: any) {
    if (e.target.checked) {
      this.selectedGridData = this.pagedItems.length == 10 ? this.grid : this.pagedItems;

      for (const element of this.grid) { element.childCheckBox = true }
    } else {

      this.selectedGridData = [];
      for (const element of this.grid) { element.childCheckBox = false }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.selectedGridData?.some((copied: any) => copied.TEMPLATE_ID === checked.TEMPLATE_ID)) {
      this.selectedGridData.push(checked);
    }

    this.parentCheckBox = this.grid.every((r: any) => r.childCheckBox);
  }

  onChildUnchecked(unchecked: any) {
    this.selectedGridData = this.selectedGridData?.filter((copied: any) => copied.TEMPLATE_ID !== unchecked.TEMPLATE_ID);
  }

  refreshGrid() {
    [this.grid, this.gridObj] = [[], {}];
    this.getCall();
  }

  getClobValue(primeIdentifier: string, columnName: string): Promise<string> {
    const docObj = {

      primeIdentifier: primeIdentifier,
      tableView: 'OOS_LAB_INVESTIGATION_CATEGORY_VW', // Update this to the correct view name
      columnName: columnName
    };

    return new Promise((resolve, reject) => {
      this.appService.getClobToViewAudit(docObj).subscribe({
        next: (response: any) => resolve(response.result || ''),
        error: (error) => {
          console.error('Error fetching CLOB value:', error);
          reject(error);
        },
        complete: () => {
          console.log('CLOB value retrieval completed.');
        }
      });
    });
  }


}
